import { useContext, useEffect, useState } from "react";
import {
  Box,
  Flex,
  Heading,
  Stack,
  Radio,
  Text,
  RadioGroup,
} from "@chakra-ui/react";
// import { PhoneIcon, EmailIcon, CloseIcon } from "@chakra-ui/icons";
import Sidebar from "../Component/Sidebar";
import NotificationsTemplate from "../Component/Actions/Notification";
import { LeadTable } from "../Component/Leads/LeadTable";
// import { customerFilters, leadFilters } from "../Config/filter";
import WhatsappTemplate from "../Component/Actions/WhatsappTemplate";
import EmailTemplate from "../Component/Actions/EmailTemplate";
import { ChatTemplate } from "../Component/Actions/ChatTemplate";
import { appContext } from "../Context/AppContext";
import { CustomerTable } from "../Component/Customers/CustomerTable";
import { convertToTitle } from "../helper/helper";
import { ReachoutTemplate } from "../Component/Reachout/ReachoutTemplate";
import { ReachoutLogsTable } from "../Component/Reachout/ReachoutLogsTable";
import { useSearchParams } from "react-router-dom";
import { ExpertRecords } from "./analytics/ExpertRecords";
import { ContactRecords } from "./analytics/ContactRecords";
import { EhcRecords } from "./analytics/EhcRecords";
import { AssessmentRecords } from "./analytics/AssessmentRecords";
import { SessionRecords } from "./analytics/SessionRecords";
import { BookingRecords } from "./analytics/BookingRecords";
import { UserRegistrationRecords } from "./analytics/UserRegistrationRecords";
import { FollowupLogsTable } from "../Component/Followup/FollowupLogsTable";
import { CgProfile } from "react-icons/cg";

const Dashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const useremail = searchParams.get("useremail");
  const source = searchParams.get("source");
  const status = searchParams.get("status") || "";

  const loggedInUser = localStorage.getItem("logged_in_user_id");

  const pageIdMapping: any = {
    HOT: "hot-leads",
    WARM: "warm-leads",
    COLD: "cold-leads",
    SINGLE: "single",
    SUBSCRIPTION: "subscription",
    null: "",
    "": "",
  };
  const { pageId, setPageId } = useContext(appContext);

  const [action, setAction] = useState("");
  const [reachoutNotificationId, setReachoutNotificationId] = useState("");
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [notificationId, setNotificationId] = useState("");
  const [userId, setUserId] = useState("");
  const [appUserId, setAppUserId] = useState("");
  const [emailVariables, setEmailVariables] = useState<any>();

  //email
  const [variableValues, setVariableValues] = useState<
    { key: string; value: string }[]
  >([]);

  //whatsapp
  const [whatsappVariables, setWhatsappVariables] = useState<any>([]);
  const [whatsappImageUrl, setWhatsappImageUrl] = useState("");

  // console.log("email Variables", emailVariables);
  // const [lastSyncedBy, setLastSyncedBy] = useState("");
  // console.log("Page ID" + pageId);

  const [value, setValue] = useState("3");

  const [followupLogData, setFollowupLogData] = useState<any>({
    email: "",
    original_status: "",
    current_status: "",
  });

  const [isWhatsappUnavailable, setIsWhatsappUnavailable] = useState(false);

  const handleChange = (newValue: any) => {
    setValue(newValue);

    if (newValue === "1") {
      setAction("whatsapp");
    } else if (newValue === "2") {
      setAction("notification");
    } else {
      setAction("email");
    }
  };

  const capitalize = (str: any) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  useEffect(() => {
    const selectedPageId =
      status && pageIdMapping[status]
        ? pageIdMapping[status]
        : pageId
        ? pageId
        : "cold-leads";

    setPageId(selectedPageId);
  }, [status, pageId]);

  useEffect(() => {
    if (["leads-reachout", "customer-reachout"].includes(pageId)) {
      setValue("3");
      setAction("email");
    }
  }, [pageId]);

  return (
    <Flex w="100%">
      <Sidebar setAction={setAction} />
      <Box bg="white" minH="100vh" w="90%" ml="10%" overflowX="auto">
        {/* Top Bar */}
        <Flex
          bg="teal.500"
          color="white"
          py={5}
          px={6}
          align="center"
          justify="space-between"
        >
          <Heading textAlign="center" flex={1} size="lg">
            {convertToTitle(pageId)}
          </Heading>

          <Flex align="center" gap={2}>
            <CgProfile size={20} />
            <Text fontSize="md" fontWeight="semibold">
              {(loggedInUser?.includes("_")
                ? capitalize(loggedInUser.split("_")[1])
                : capitalize(loggedInUser)) || "User"}
            </Text>
          </Flex>
        </Flex>

        {["leads-reachout", "customer-reachout"].includes(pageId) && (
          <RadioGroup bg="#fdb508" p={6} value={value} onChange={handleChange}>
            <Stack direction="row" spacing={10}>
              <Radio value="1">Whatsapp Template</Radio>
              <Radio value="2">App Notification</Radio>
              <Radio value="3">Email</Radio>
            </Stack>
          </RadioGroup>
        )}

        {!["leads-reachout", "customer-reachout"].includes(pageId) &&
          action && (
            <Box
              bg="#e98b90"
              color="white"
              fontWeight="bold"
              textAlign="center"
              textColor="black"
              py={4}
              px={6}
            >
              {action}
            </Box>
          )}

        {action === "notification" && (
          <NotificationsTemplate
            setId={setReachoutNotificationId}
            userId={userId}
            pageId={pageId}
            notificationId={notificationId}
            setNotificationId={setNotificationId}
          />
        )}
        {action === "call" && (
          <ChatTemplate
            name={name}
            phoneNumber={phoneNumber}
            followupLogData={followupLogData}
            setFollowupLogData={setFollowupLogData}
            isWhatsappUnavailable={isWhatsappUnavailable}
          />
        )}
        {action === "whatsapp" && (
          <WhatsappTemplate
            setId={setReachoutNotificationId}
            userId={userId}
            pageId={pageId}
            notificationId={notificationId}
            setNotificationId={setNotificationId}
            emailVariables={emailVariables}
            whatsappVariables={whatsappVariables}
            whatsappImageUrl={whatsappImageUrl}
            setWhatsappVariables={setWhatsappVariables}
            setWhatsappImageUrl={setWhatsappImageUrl}
          />
        )}
        {action === "email" && (
          <EmailTemplate
            emailVariables={emailVariables}
            setId={setReachoutNotificationId}
            pageId={pageId}
            userId={userId}
            appUserId={appUserId}
            notificationId={notificationId}
            setNotificationId={setNotificationId}
            variableValues={variableValues}
            setVariableValues={setVariableValues}
          />
        )}

        {["single", "subscription"].includes(pageId) && (
          <CustomerTable
            setAction={setAction}
            setUserId={setUserId}
            setAppUserId={setAppUserId}
            setName={setName}
            setSearchParams={setSearchParams}
            urlSearch={useremail}
            urlStatus={status}
            urlSource={source}
            setPhoneNumber={setPhoneNumber}
            setEmailVariables={setEmailVariables}
            setFollowupLogData={setFollowupLogData}
            setIsWhatsappUnavailable={setIsWhatsappUnavailable}
          />
        )}

        {["hot-leads", "warm-leads", "cold-leads"].includes(pageId) && (
          <LeadTable
            setAction={setAction}
            setAppUserId={setAppUserId}
            setName={setName}
            setPhoneNumber={setPhoneNumber}
            setUserId={setUserId}
            setSearchParams={setSearchParams}
            urlSearch={useremail}
            urlStatus={status}
            urlSource={source}
            setEmailVariables={setEmailVariables}
            setFollowupLogData={setFollowupLogData}
            setIsWhatsappUnavailable={setIsWhatsappUnavailable}
          />
        )}
        {["leads-reachout", "customer-reachout"].includes(pageId) && (
          <ReachoutTemplate
            type={action}
            id={reachoutNotificationId}
            variableValues={variableValues}
            whatsappVariables={whatsappVariables}
            whatsappImageUrl={whatsappImageUrl}
            setEmailVariables={setEmailVariables}
          />
        )}
        {["reachout-logs"].includes(pageId) && <ReachoutLogsTable />}
        {["followup-logs"].includes(pageId) && <FollowupLogsTable />}
        {["analytics"].includes(pageId) && <ExpertRecords />}
        {["contact-analytics"].includes(pageId) && <ContactRecords />}
        {["free-consultation-analytics"].includes(pageId) && <EhcRecords />}
        {["assessment-analytics"].includes(pageId) && <AssessmentRecords />}
        {["session-analytics"].includes(pageId) && <SessionRecords />}
        {["booking-analytics"].includes(pageId) && <BookingRecords />}
        {["user-registration-analytics"].includes(pageId) && <UserRegistrationRecords />}
      </Box>
    </Flex>
  );
};

export default Dashboard;
